<template>
  <div class="h-100">
    <cc-sidebar ref="sidebarRightFilter" id="sidebar-right-filter"
                title="Điều kiện tìm kiếm"
                @onOpenedSidebar="onOpenedSidebar">
      <template slot="body">
        <filter-panel ref="filterPanel"></filter-panel>
      </template>
      <template slot="footer">
        <div class="align-items-center p-3">
          <CRow>
            <CCol :col="{size: 10, offset: 1}">
              <CRow>
                <CCol col="6">
                  <CButton block color="danger" size="sm" @click="resetCondition">Xóa điều kiện</CButton>
                </CCol>
                <CCol col="6">
                  <CButton block color="success" size="sm" @click="filterListWithCondition">Tìm kiếm</CButton>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </div>
      </template>
    </cc-sidebar>
    <CRow class="h-100">
      <CCol class="h-100 px-2">
        <cc-ve-table ref="ccVeTable" namespace="user" :columns="columns" :scroll-width="1200"
                     :expand-option="expandOption" :cell-style-option="cellStyleOption"
                     :event-custom-option="eventCustomOption" @onChangeItemsPerPage="onChangeItemsPerPage"
                     @onChangePagination="onChangePagination" @itemSelectedLength="getItemSelectedLength">
          <template slot="cCardHeader">
            <CRow>
              <CCol col="7">
                <h4 class="text-uppercase mb-0 mt-1">Quản lý người dùng</h4>
              </CCol>
              <CCol col="5" class="float-right">
                <CRow>
                  <CCol :col="{size: 8, offset: 4}">
                    <CRow>
                      <CCol :col="{size: 5, offset: 5}">
                        <CButton block color="danger"
                                 :disabled="!itemSelectedLength"
                                 @click="deleteSelectedTable">
                          Xóa
                        </CButton>
                      </CCol>
                      <CCol col="2" class="text-center align-self-center">
                        <CLink href="#" v-b-toggle.sidebar-right-filter>
                          <CIcon name="cil-filter" height="20"/>
                        </CLink>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </template>
        </cc-ve-table>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import CcVeTable from '@/components/common/tableList/CcVeTable'
import CcSidebar from '@/components/common/CcSidebar'
import {USER_SEX, USER_TYPE, USER_VERIFY} from '@/common/Constant'
import {format} from '@/mixins/format'
import {SHOW_TOAST_2} from '@/common/lib'
import ExpandInfoList from '@/components/user/ExpandInfoList'
import FilterPanel from '@/components/user/FilterPanel'
import * as _ from 'lodash'

export default {
  name: 'List',
  mixins: [
    format
  ],
  components: {
    CcVeTable,
    // eslint-disable-next-line vue/no-unused-components
    ExpandInfoList,
    CcSidebar,
    FilterPanel
  },
  data() {
    return {
      itemSelectedLength: 0,
      deleteFailId: [],
      columns: [
        {
          title: 'Thông tin',
          children: [
            {
              field: 'name',
              key: 'id',
              title: 'Tài khoản',
              align: 'left',
              width: 160,
              renderBodyCell: ({row, column}) => {
                return (
                  <CLink class="font-weight-bold" onclick={() => this.moveUserInfo(row)}>
                    {row[column.field]}
                  </CLink>
                )
              }
            },
            {
              field: 'full_name',
              key: 'full_name',
              title: 'Tên đầy đủ',
              align: 'left',
              width: 180
            },
            {
              field: 'user_sex',
              key: 'user_sex',
              title: 'Giới tính',
              align: 'center',
              width: 100,
              renderBodyCell: ({row, column}) => {
                let _status
                USER_SEX.forEach(sex => {
                  if (sex.id === row[column.field]) {
                    _status = (
                      <CIcon name={sex.classIcon} class={sex.className} height="22"/>
                    )
                  }
                })
                return _status
              }
            }
          ]
        },
        {
          title: 'Tài sản',
          children: [
            {
              field: 'dakland',
              key: 'dakland',
              title: 'Dakland',
              align: 'right',
              width: 130,
              renderBodyCell: ({row, column}) => {
                return <strong>{this.fNumber(row[column.field])}</strong>
              }
            },
            {
              field: 'coin',
              key: 'coin',
              title: 'Coin',
              align: 'right',
              width: 130,
              renderBodyCell: ({row, column}) => {
                return <strong>{this.fNumber(row[column.field])}</strong>
              }
            }
          ]
        },
        {
          field: 'user_type',
          key: 'user_type',
          title: 'Phân loại',
          align: 'left',
          width: 150,
          renderBodyCell: ({row, column}) => {
            let _className
            USER_TYPE.forEach(userType => {
              if (userType.id === row[column.field]) {
                _className = userType.className
              }
            })
            return (
              <b-form-select
                v-model={row[column.field]}
                options={USER_TYPE}
                value-field="id"
                text-field="name"
                class={`select-render-body-cell ${_className}`}
                onChange={_userTypeId => {
                  this.onChangeValueCell(_userTypeId, 'user_type', row.id, column.title)
                }}>
              </b-form-select>
            )
          }
        },
        {
          field: 'is_verified',
          key: 'is_verified',
          title: 'Trạng thái',
          align: 'left',
          width: 150,
          renderBodyCell: ({row, column}) => {
            let _className
            USER_VERIFY.forEach(userVerify => {
              if (userVerify.id === row[column.field]) {
                _className = userVerify.className
              }
            })
            return (
              <b-form-select
                v-model={row[column.field]}
                options={USER_VERIFY}
                value-field="id"
                text-field="name"
                class={`select-render-body-cell ${_className}`}
                onChange={_userVerifyId => {
                  this.onChangeValueCell(_userVerifyId, 'is_verified', row.id, column.title)
                }}>
              </b-form-select>
            )
          }
        }
      ],
      expandOption: {
        trigger: 'cell',
        render: ({row}) => {
          return (
            <expand-info-list row={row}>
            </expand-info-list>
          )
        }
      },
      cellStyleOption: {
        bodyCellClass: ({row, column}) => {
          if (this.deleteFailId && this.deleteFailId.length) {
            if (this.deleteFailId.includes(row.id)) {
              if (['checkbox', 'expand'].includes(column.type)) {
                return 'row-delete-failed cursor-pointer'
              } else {
                return 'row-delete-failed'
              }
            }
          } else {
            if (['checkbox', 'expand'].includes(column.type)) {
              return 'cursor-pointer'
            }
          }
        }
      },
      eventCustomOption: {
        bodyCellEvents: ({row, column}) => {
          return {
            click: () => {
              if (column.key !== 'expand' && !['name', 'user_type', 'is_verified'].includes(column.field)) {
                const currentRowKey = row['id']
                this.$refs.ccVeTable.changeSelectedRowKeysByRowClick(currentRowKey)
              }
            }
          }
        }
      }
    }
  },
  async mounted() {
    if (this.$refs.ccVeTable) {
      await this.getDataTable(this.$refs.ccVeTable.$refs.dataAllListPagination.itemsPerPage)
      this.$refs.ccVeTable.showToastGetDataList('user')
    }
  },
  methods: {
    ...mapActions('auth', ['userLogout', 'getUserList']),
    ...mapActions('user', ['getDataList', 'updateOnCellTable', 'deleteSelectedList']),
    onOpenedSidebar() {
      this.$refs.filterPanel.getUserListWhenOpenSidebar()
    },
    async filterListWithCondition() {
      this.$refs.sidebarRightFilter.$refs.ccSidebar.hide()
      this.$refs.ccVeTable.$refs.dataAllListPagination.currentPage = 1
      await this.getDataTable(this.$refs.ccVeTable.$refs.dataAllListPagination.itemsPerPage)
      this.$refs.ccVeTable.showToastGetDataList('user')
      if (this.deleteFailId && this.deleteFailId.length) {
        this.deleteFailId = []
        this.$refs.ccVeTable.unselectedAll()
      }
    },
    resetCondition() {
      this.$refs.filterPanel.resetCondition()
    },
    async getDataTable(pageSize, currentPage = 1) {
      this.$refs.ccVeTable && this.$refs.ccVeTable.loadingInstance && this.$refs.ccVeTable.loadingInstance.show()
      let _param = {
        current_page: currentPage,
        page_size: pageSize,
        filter: {}
      }
      const _filterMap = this.$refs.filterPanel.filterMap
      _.merge(_param['filter'], _filterMap)
      await this.getDataList(_param)
      this.$refs.ccVeTable && this.$refs.ccVeTable.loadingInstance && this.$refs.ccVeTable.loadingInstance.close()
    },
    async onChangeItemsPerPage(_itemsPerPage) {
      await this.getDataTable(_itemsPerPage)
      this.$refs.ccVeTable.showToastGetDataList('user')
      if (this.deleteFailId && this.deleteFailId.length) {
        this.deleteFailId = []
        this.$refs.ccVeTable.unselectedAll()
      }
    },
    onChangePagination(_currentPage) {
      this.getDataTable(this.$refs.ccVeTable.$refs.dataAllListPagination.itemsPerPage, _currentPage)
      if (this.deleteFailId && this.deleteFailId.length) {
        this.deleteFailId = []
        this.$refs.ccVeTable.unselectedAll()
      }
    },
    async onChangeValueCell(value, key, rowId, title) {
      const _param = {
        updated_user_id: rowId
      }
      _param[key] = value
      const res = await this.updateOnCellTable(_param)
      await this.showToastUpdateOrDeleteOnList(res, title, 0, rowId, key, value)
    },
    async showToastUpdateOrDeleteOnList(_res, _titleField, _countItemDeleted, _userId, _keyChange, _valueChange) {
      if (_res) {
        if (_res === 'updateOnCellTableSuccess') {
          SHOW_TOAST_2('success', `Cập nhật <b>"${_titleField}"</b> thành công.`)
          if (_userId === this.$cookies.get('userInfo')['userId']) {
            if ((_keyChange === 'user_type' && _valueChange !== 3) || (_keyChange === 'is_verified' && _valueChange === 2)) {
              await this.logoutWhenUpdateOrDelete()
              return
            }
          } else {
            await this.getUserList()
          }
        } else if (_res === 'deleteSelectedTableSuccess') {
          SHOW_TOAST_2('success', `Xóa thành công <b>${_countItemDeleted}</b> user.`)
          if (_userId.includes(this.$cookies.get('userInfo')['userId'])) {
            await this.logoutWhenUpdateOrDelete()
            return
          } else {
            await this.getUserList()
          }
        } else {
          SHOW_TOAST_2('error', 'Không thể thực hiện. Vui lòng kiểm tra lại!')
        }
      } else {
        SHOW_TOAST_2('error', 'Thực hiện thất bại.')
      }
      await this.getDataTable(this.$refs.ccVeTable.$refs.dataAllListPagination.itemsPerPage, this.$refs.ccVeTable.$refs.dataAllListPagination.currentPage)
    },
    async deleteSelectedTable() {
      const _countItemDeleted = this.$refs.ccVeTable.dataTableSelected.length
      const confirm = window.confirm(`Bạn có chắc chắn muốn xóa ${_countItemDeleted} user?`)
      if (confirm) {
        if (this.$refs.ccVeTable.dataTableSelected && this.$refs.ccVeTable.dataTableSelected.length) {
          const res = await this.deleteSelectedList(this.$refs.ccVeTable.dataTableSelected)
          if (res) {
            if (res === 'deleteSelectedTableSuccess') {
              await this.$refs.filterPanel.getUserListAfterDelete()
              this.deleteFailId = []
              this.$refs.ccVeTable.unselectedAll()
            } else {
              this.deleteFailId = res.data['failed_ids']
            }
          }
          await this.showToastUpdateOrDeleteOnList(res, null, _countItemDeleted, this.$refs.ccVeTable.dataTableSelected)
        }
      }
    },
    async logoutWhenUpdateOrDelete() {
      const res = await this.userLogout()
      if (res) {
        this.$cookies.remove('userInfo')
        await this.$router.push({
          name: 'Login',
          params: {
            pathName: window.location.pathname
          },
          query: {
            isExpired: true
          }
        })
      }
    },
    async moveUserInfo(userInfo) {
      if (this.$cookies.isKey('userInfo')) {
        let _name = 'User Info'
        if (userInfo.id === this.$cookies.get('userInfo')['userId']) {
          _name = 'My Profile'
        }
        await this.$router.push({
          name: _name,
          params: {
            userInfo: userInfo
          }
        })
      } else {
        await this.$router.push({
          name: 'Login',
          params: {
            pathName: window.location.pathname
          },
          query: {
            isExpired: true
          }
        })
      }
    },
    getItemSelectedLength(value) {
      this.itemSelectedLength = value
    }
  }
}
</script>

<style scoped></style>
